import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="ble-statistics"
export default class extends Controller {
    static targets = ["sensor", "eventDay"]

    connect() {
        this.handleChange ||= event => event.currentTarget.form.requestSubmit()
        this.sensorTarget.addEventListener("change", this.handleChange)
        this.eventDayTarget.addEventListener("change", this.handleChange)
    }

    disconnect() {
        this.sensorTarget.removeEventListener("change", this.handleChange)
        this.eventDayTarget.removeEventListener("change", this.handleChange)
    }
}
